/**
 * 对dayjs二次封装
 * Created by slipkinem on 2018/8/9 at 下午4:59.
 */
import dayjs, { UnitType, ConfigType as MixedDate } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import UTC from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(UTC);

export { default as dayjs } from 'dayjs';

export const format = (value: Date): string => dayjs(value).format('YYYY-MM-DD HH:mm:ss');

export const formatToDay = (value: MixedDate): string => dayjs(value).format('YYYY-MM-DD');

export const getHour = (
  value1: MixedDate,
  value2: MixedDate,
  unit: UnitType = 'hour',
): number => Math.ceil(dayjs(value1).diff(dayjs(value2), unit, true));

/**
 * 根据开始时间和结束时间计算累计的年数
 * @param value1 结束时间
 * @param value2 开始时间
 * @param unit
 */
export const getYear = (value1: MixedDate, value2: MixedDate): number => {
  const endYear = dayjs(value1);
  const startYear = dayjs(value2);

  if (endYear.isValid() && startYear.isValid()) {
    return endYear.diff(startYear, 'year', true);
  }

  return 0;
};

/**
 * 通过开始时间和累计的年数计算结束时间
 * @param value1 开始时间
 * @param value2 累计年数
 * @param unit
 */
export const getEndYear = (value1: MixedDate, value2: number): string => {
  const res = dayjs(value1).add(value2, 'year');

  if (res.isValid()) {
    return res.format('YYYY-MM-DD HH:mm:ss');
  }

  return '';
};

export const toUnixTime = (time: string): string => {
  if (String(time).length > 8) {
    return time;
  }
  return `${dayjs(String(time), 'YYYYMMDD').unix() * 1000}`;
};
